import React, { useState } from 'react';
import { Outlet, NavLink, Link, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Tags,
  CheckSquare,
  LogOut,
  Settings,
  Store,
  Menu,
  X,
  Briefcase,
  PlusCircle,
  Upload
} from 'lucide-react';
import { supabase } from '../../config/supabase';

const AdminLayout = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      navigate('/admin/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/admin' },
    { icon: PlusCircle, label: 'Add Business', path: '/admin/add-business' },
    { icon: PlusCircle, label: 'Register User', path: '/admin/register-user' },
    { icon: Upload, label: 'Import Businesses', path: '/admin/import-businesses' },
    { icon: Users, label: 'Traders', path: '/admin/traders' },
    { icon: Users, label: 'Crafties', path: '/admin/crafties' },
    { icon: Users, label: 'Hospitality', path: '/admin/hospitality' },
    { icon: Users, label: 'Professionals', path: '/admin/professionals' },
    { icon: Briefcase, label: 'Professions', path: '/admin/professions' },
    { icon: Tags, label: 'Categories', path: '/admin/categories' },
    { icon: CheckSquare, label: 'Approvals', path: '/admin/approvals' },
    { icon: Settings, label: 'Settings', path: '/admin/settings' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 bg-white border-b">
        <Link to="/" className="flex items-center">
          <Store className="w-8 h-8 text-blue-600 mr-2" />
          <span className="font-bold text-xl">LocalHub</span>
        </Link>
        
        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden p-2"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <div className="flex h-[calc(100vh-56px)]">
        {/* Sidebar for Desktop */}
        <div className="hidden md:block w-64 bg-white border-r">
          <nav className="mt-5 px-2">
            {menuItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center px-4 py-2 mt-2 text-sm ${
                    isActive
                      ? 'text-blue-600 bg-blue-50 rounded-md'
                      : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md'
                  }`
                }
              >
                <item.icon className="w-5 h-5 mr-3" />
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden fixed inset-0 z-50 bg-white">
            <div className="flex flex-col h-full">
              <div className="flex items-center justify-between px-4 py-3 border-b">
                <Link to="/" className="flex items-center">
                  <Store className="w-8 h-8 text-blue-600 mr-2" />
                  <span className="font-bold text-xl">LocalHub</span>
                </Link>
                <button
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="p-2"
                >
                  <X size={24} />
                </button>
              </div>
              <nav className="flex-1 px-2 py-4">
                {menuItems.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className={({ isActive }) =>
                      `flex items-center px-4 py-3 text-base ${
                        isActive
                          ? 'text-blue-600 bg-blue-50 rounded-md'
                          : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md'
                      }`
                    }
                  >
                    <item.icon className="w-6 h-6 mr-3" />
                    {item.label}
                  </NavLink>
                ))}
              </nav>
            </div>
          </div>
        )}

        {/* Main Content */}
        <div className="flex-1 overflow-auto p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
